<script setup lang="ts"></script>

<template>
  <div :class="$style.row">
    <section :class="[$style.year, $style.row__year]">
      <slot name="age" />
    </section>

    <section :class="[$style.balance, $style.row__balance]">
      <slot name="balance" />
    </section>

    <section :class="[$style.asset, $style.row__asset]">
      <slot name="assets" />
    </section>
  </div>
</template>

<style lang="scss" module>
.row {
  display: flex;
  align-items: center;

  &__year {
    flex: 2;
  }

  &__balance {
    min-width: 90px;
    flex: 1;
  }

  &__asset {
    min-width: 90px;
    align-self: stretch;
    flex: 1;
  }
}
</style>
